<div class="a-progressbar-modal">
  <span class="ui-button ui-button-icon-only close-btn"
  *ngIf="closable" (click)="onClose()" ><i class="fas fa-times"></i></span>
  <div class="title">{{title}}</div>
  <p-progressBar
    [value]="value$|async" [showValue]="showValue" [style]="style" [styleClass]="styleClass"
    [unit]="unit" [mode]="mode"
  >
  </p-progressBar>
</div>
